import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
// React.StrictMode intentionally disabled: this preview IS the CEO's
// live environment and the voice feature keeps stateful WebRTC + server
// session state. StrictMode's dev-only double-mount tears those down
// between the two mounts, which looked like "panel resets to Off right
// after the SDK loads".
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
